<template>
  <base-page-layout title="Destaques">
    <div class="highlights-index-container">
      <div class="tabs-button-header">
        <mf-tabs-menu v-model="tab" :tabs="tabs" />
        <div class="tab-buttons">
          <mf-button id="highlights-new" icon="add" label="Novo destaque" @click="newHighlight" />
        </div>
      </div>
      <div v-if="tab === 0" :key="tab">
        <voucher-table
          v-if="isFranchisee"
          class="mb-3"
          :franchisee="true"
          :units="units"
          :itemsFilter="filterListFranchisee[tab]"
          :default-table-sort-by="'updatedAt'"
          :default-table-sort-desc="true"
        >
          <template v-slot:title> Destaques da rede </template>
        </voucher-table>
        <voucher-table class="mb-3" :units="units" :itemsFilter="filterList[tab]" :default-table-sort-by="'updatedAt'" :default-table-sort-desc="true">
          <template v-slot:title> Meus destaques</template>
        </voucher-table>
      </div>
      <div v-if="tab === 1" :key="tab">
        <voucher-table
          v-if="isFranchisee"
          class="mb-3"
          :franchisee="true"
          :units="units"
          :itemsFilter="filterListFranchisee[tab]"
          :default-table-sort-by="'updatedAt'"
          :default-table-sort-desc="true"
        >
          <template v-slot:title> Destaques da rede </template>
        </voucher-table>
        <voucher-table class="mb-3" :units="units" :itemsFilter="filterList[tab]" :default-table-sort-by="'updatedAt'" :default-table-sort-desc="true">
          <template v-slot:title> Meus destaques </template>
        </voucher-table>
      </div>
    </div>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'
import VoucherTable from '../components/index/VoucherTable.vue'
import { getStatusLabel } from '@/config/helpers.js'

export default {
  name: 'HighlightIndex',
  components: {
    BasePageLayout,
    VoucherTable,
  },
  data() {
    return {
      tab: 0,
      filterListFranchisee: [
        [
          { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
          { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        ],
        [{ label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true }],
      ],
      filterList: [
        [
          { label: getStatusLabel('DRAFT').text, value: 'DRAFT', color: getStatusLabel('DRAFT').color, active: true },
          { label: getStatusLabel('ACTIVE').text, value: 'ACTIVE', color: getStatusLabel('ACTIVE').color, active: true },
          { label: getStatusLabel('SCHEDULED').text, value: 'SCHEDULED', color: getStatusLabel('SCHEDULED').color, active: true },
        ],
        [{ label: getStatusLabel('FINISHED').text, value: 'FINISHED', color: getStatusLabel('FINISHED').color, active: true }],
      ],
    }
  },
  computed: {
    units() {
      return this.$store.getters.units
    },
    isFranchisee() {
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
    tabs() {
      return [
        {
          name: 'Ofertas em destaque',
          itemsLength: 0,
          haveLength: false,
        },
        {
          name: 'Histórico',
          itemsLength: 0,
          haveLength: false,
        },
      ]
    },
  },
  methods: {
    newHighlight() {
      this.$router.push('/mobile/destaques/novo')
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-button-header {
  position: relative;
  margin-bottom: 20px;
  .tab-buttons {
    position: absolute;
    top: 5px;
    right: 0;
  }
}
</style>
